import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";

import LoggedInNav from "../layout/IME/LoggedInNav";
import LoggedOutNav from "../layout/IME/LoggedOutNav";
import HomeFooter from "../layout/IME/HomeFooter";
import SecondaryLogo from "../layout/IME/SecondaryLogo";

const About = ({ auth: { user, isAuthenticated } }) => {
  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {isAuthenticated ? <LoggedInNav /> : <LoggedOutNav />}
      <div className="about-container">
        <div className="page-jumbotron">
          <SecondaryLogo />
        </div>
      </div>
      <div className="images-container">
        <div className="about-image-container"></div>
        <div className="about-image-container image-two"></div>
        <div className="about-image-container image-three"></div>
      </div>
      <div className="about-container">
        <section className="about-info">
          <div className="about-left-container">
            <h2 className="about-heading">The future is NOW</h2>
            <p className="about-text">
              ime is a convenient resourceful intellectwork that strives to
              benefit its users with the different tools needed in order to
              excel and succeed in their career field of choice. Quick apply for
              jobs, no regristration required, or take full advantage of some of
              our amazing site features! Join and discover job and mentor
              streams, gain and expand knowledge from mentor courses, share your
              thoughts amongst your peers in live discussions and much more!
              Register and get started today.
            </p>
          </div>
          <div className="about-right-container">
            <div className="about-video-container">
              <div className="about-overlay">
                <p className="letters">
                  <span className="ime green">i</span>
                  <span className="ime red">m</span>
                  <span className="ime blue">e</span>
                </p>
              </div>
              <video
                src={
                  "https://ime.sfo3.cdn.digitaloceanspaces.com/videos/Globe.mp4"
                }
                autoplay="true"
                loop
                className="fill-video"
              ></video>
              <p className="small">Innovate the world around you!</p>
            </div>
          </div>
        </section>
        <section className="about-info">
          <div className="about-left-container">
            <div className="about-video-container">
              <div className="secondary-overlay"> </div>
              <img
                className="about-img"
                src={
                  "https://ime.sfo3.cdn.digitaloceanspaces.com/img/about_huddle.jpg"
                }
                alt="huddle"
              />
            </div>
            <p className="small">Explore ime to find your dream career!</p>
          </div>
          <div className="about-right-container">
            <h2 className="about-heading">
              {`ime career searching > traditional career searching`}
            </h2>
            <p className="about-text">
              Gone are the monotonous days where career searching is a constant
              struggle. No more going online, searcing for an array of careers
              that may 'hopefully' appeal to you, and waiting for employers to
              randomly select your resume out the stack of applicants. ime
              introduces a new and innovative approach towards finding your
              dream career. With live job stream, employers are able to answer
              the 'ice breaker' questions for their audience via live stream, or
              give you a first hand preview of what your new top floor office
              with an incredible view will appear as with VR Tours. These new
              ideas of career searching present an in depth and fun new way of
              career searching.
            </p>
          </div>
        </section>
        <section className="about-info">
          <div className="about-left-container">
            <h2 className="about-heading">
              {`ime online learning > traditional learning`}
            </h2>
            <p className="about-text">
              With learning becoming more and more easily accessable online, ime
              sees hope in bringing trades, skills and knowledge to it's users
              with mentor courses. While college is a great resource to gain
              knowledge, not everyone is the right fit for such an environment.
              Our mentor online courses differ from other sites, in which the
              mentor of whom created the course you desire to learn about, can
              mentor and explain any complex topics you may stumble upon via
              live stream chat or *live link. Subscribe to your favorite mentors
              with monthly subscriptions or ime monthly subscription to receive
              access to their most recent course, alongside your subscription.
            </p>
          </div>
          <div className="about-right-container">
            <div className="about-video-container">
              <div className="secondary-overlay"> </div>
              <img
                className="about-img"
                src={
                  "https://ime.sfo3.cdn.digitaloceanspaces.com/img/about_learning.jpg"
                }
                alt="huddle"
              />
            </div>
            <p className="small">
              Learning on ime is fun and rewarding!
              <br />
              <br />
              <span className="side-note">
                *Live link requests are for subscribers to that specific mentor
                only
              </span>
            </p>
          </div>
        </section>
        <section className="about-info">
          <div className="about-left-container">
            <div className="about-video-container">
              <div className="secondary-overlay"> </div>
              <img
                className="about-img"
                src={
                  "https://ime.sfo3.cdn.digitaloceanspaces.com/img/about_discussion.PNG"
                }
                alt="discussion"
              />
            </div>
            <div className="about-video-container">
              <div className="secondary-overlay"> </div>
              <img
                className="about-img"
                src={
                  "https://ime.sfo3.cdn.digitaloceanspaces.com/img/about_discussion.PNG"
                }
                alt="discussion"
              />
            </div>
          </div>
          <div className="about-right-container">
            <h2 className="about-heading">
              {`ime intellectworking > 'social' networking`}
            </h2>
            <p className="about-text">
              Communication is key and ime has no such shortage. We offer a
              multitude of ways to communicate from live chat streams, live
              discussions, post comments, traditional text messaging and more!
              Do you have a passion for writing? Publish an article and share it
              with the world of ime. Search and discover published articles from
              your peers and leave constructive feedback on what your thoughts
              are. Within your user profile post feed, create a post for your
              following to view and comment. Lastly, message your online friends
              through traditional text messaging and enjoy the fun of
              communicating with one another.
            </p>
            <p className="small">
              Online communication has never been this fun!
            </p>
          </div>
        </section>
      </div>
      <HomeFooter />
    </Fragment>
  );
};

About.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(About);
